export default function OurServicesPage() {
  const services = [
    {
      icon: "ri-shield-user-line",
      title: "Cybersecurity Consulting",
      description:
        "Expert security assessments and strategic consulting to identify vulnerabilities and strengthen your digital infrastructure against evolving threats.",
    },
    {
      icon: "ri-smartphone-line",
      title: "Mobile App Development",
      description:
        "Custom mobile applications built with security-first architecture, ensuring your business data remains protected across all platforms.",
    },
    {
      icon: "ri-cloud-line",
      title: "Cloud Solutions",
      description:
        "Secure cloud migration and management services that optimize performance while maintaining enterprise-grade security standards.",
    },
    {
      icon: "ri-code-box-line",
      title: "Web Development",
      description:
        "Modern web solutions built with cutting-edge frameworks, designed for speed, security, and scalability.",
    },
    {
      icon: "ri-fingerprint-line",
      title: "Identity Management",
      description:
        "Comprehensive identity and access management solutions that protect your organization's sensitive data and resources.",
    },
    {
      icon: "ri-brain-line",
      title: "AI Integration",
      description:
        "Intelligent automation and AI-powered solutions that enhance productivity while maintaining robust security protocols.",
    },
  ];

  return (
    <main>
      {/* Hero Section */}
      <section className="relative h-[320px] md:h-[400px] flex items-center justify-center overflow-hidden bg-foreground-900">
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900 to-foreground-900" />
        <div className="relative z-10 text-center px-4">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight font-heading">
            Our Services
          </h1>
          <p className="mt-4 text-lg text-foreground-300 max-w-2xl mx-auto">
            Comprehensive technology solutions for modern businesses
          </p>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-white">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="text-center mb-10 md:mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground-900 mb-4 font-heading">
              What We Offer
            </h2>
            <p className="text-lg text-foreground-600 max-w-3xl mx-auto">
              Tailored technology solutions designed to drive growth and secure your digital assets
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {services.map((service, idx) => (
              <div
                key={idx}
                className="bg-background-50 p-6 md:p-8 rounded-xl border border-background-200 hover:shadow-lg transition-shadow duration-300"
              >
                <div className="w-14 h-14 bg-primary-500 rounded-xl flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-xl font-semibold text-foreground-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}